import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const showBelow = 400; // Button appears after scrolling 400px down

  const toggleVisibility = () => {
    if (window.scrollY > showBelow) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth animation
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed-bottom p-3">
      {isVisible && (
        <button type="button" className="btn btn-secondary btn-sm" onClick={scrollToTop}>
            <h3 className="text-white">⬆</h3>
        </button>
      )}
    </div>
  );
};

export default ScrollToTopButton;
